import {
  useProformaInvoicesTableDataQuery,
  useProformaInvoicesTableSummaryQuery,
} from "@src/__generated__/graphql";
import { onError } from "@src/utils/apollo";
import { useStore } from "../store";

export const useFetchTableData = () => {
  const store = useStore();

  const { loading: loadingSummary, refetch: refetchSummary } =
    useProformaInvoicesTableSummaryQuery({
      notifyOnNetworkStatusChange: true,
      variables: store.queryVariables,
      onCompleted(data) {
        if (!data) return;
        store.proformaInvoicesSummary = data.outgoingProformaInvoicesSummary;
      },
      ...onError(),
    });

  const { loading, refetch } = useProformaInvoicesTableDataQuery({
    notifyOnNetworkStatusChange: true,
    variables: store.queryVariables,
    onCompleted(data) {
      if (data) {
        store.setDataFromQuery(data);
      }
    },
    ...onError(),
  });

  store.proformaInvoicesRefetch = () => {
    refetch();
    refetchSummary();
  };

  return { loading, loadingSummary };
};
